import React from 'react'
import {
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material'
import {useSelector} from 'react-redux'
import Binocular from 'assets/images/binocular.svg'
import ErrorOutlineOutlinedIcon from 'assets/images/alert-circle-outline-icon.svg'
import {getSmallLogoByFlightNumber} from 'config/logo.constant'

const FlightStatusTable = () => {
    const results = useSelector((state: any) => state.flightStatus.response)
    const carrier = useSelector((state: any) => state.flightStatus.carrier)
    const error = useSelector((state: any) => state.flightStatus.error)
    const smallLogos = useSelector((state: any) => state.login.smallLogos)

    const showErrorMassage = () => {
        if (error === null || error.length === 0) {
            return (
                <Container className='no-results-found'>
                    <Typography variant='h5'>No results found.</Typography>
                    <Typography variant='h6'>Please try another search.</Typography>
                    <img src={Binocular} alt='icon' />
                </Container>
            )
        } else {
            return (
                <Container className='no-results-found'>
                    <Typography variant='h5'>{`There was a system error (${error}).`}</Typography>
                    <Typography variant='h6'>Please try again later.</Typography>
                    <img src={ErrorOutlineOutlinedIcon} alt='icon' />
                </Container>
            )
        }
    }

    return (
        <TableContainer component={Paper} className='table-container'>
            {results.length > 0 ? (
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Flight</TableCell>
                                <TableCell>Depart</TableCell>
                                <TableCell></TableCell>
                                <TableCell>Arrive</TableCell>
                                <TableCell>Aircraft</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {results?.map((row, index) => (
                                <TableRow key={`row-${index}`}>
                                    <TableCell key={`flight-${index}`}>
                                        <img
                                            src={getSmallLogoByFlightNumber(smallLogos, row.flight, carrier)}
                                            alt='logo'
                                            className='logo'
                                        />
                                        <span>{row.flight}</span>
                                    </TableCell>
                                    <TableCell key={`depart-${index}`}>
                                        {row.status.toLowerCase() === 'late' || row.status.toLowerCase() === 'early' ? (
                                            <>
                                                <span
                                                    className={
                                                        row.status.toLowerCase() === 'late' ? 'late-text' : 'early-text'
                                                    }
                                                >
                                                    {`${row.departureDate} - ${row.departTime}`}
                                                </span>
                                                <br />
                                                <span className='subtext'>
                                                    Sched. {row.scheduledDepartureDate} - {row.departNewTime}
                                                </span>
                                                <br />
                                            </>
                                        ) : (
                                            <>
                                                <span className='text'>
                                                    {`${row.departureDate} - ${row.departTime}`}
                                                </span>
                                                <br />
                                            </>
                                        )}
                                        <span className='subtexts'>{row.departure}</span>
                                    </TableCell>
                                    <TableCell key={`status-${index}`}>
                                        <span>
                                            <span className={`status ${row.status.toLowerCase().replace(/\s/g, '')}`}>
                                                {row.status}
                                            </span>
                                        </span>
                                    </TableCell>
                                    <TableCell key={`arrive-${index}`}>
                                        {row.status.toLowerCase() === 'late' || row.status.toLowerCase() === 'early' ? (
                                            <>
                                                <span
                                                    className={
                                                        row.status.toLowerCase() === 'late' ? 'late-text' : 'early-text'
                                                    }
                                                >
                                                    {`${row.arrivalDate} - ${row.arrivalTime}`}
                                                </span>
                                                <br />
                                                <span className='subtext'>
                                                    Sched. {row.scheduledArrivalDate} - {row.arrivalNewTime}
                                                </span>
                                                <br />
                                            </>
                                        ) : (
                                            <>
                                                <span className='text'>
                                                    {`${row.arrivalDate} - ${row.arrivalTime}`}
                                                </span>
                                                <br />
                                            </>
                                        )}
                                        <span className='subtexts'>{row.arrival}</span>
                                    </TableCell>
                                    <TableCell key={`aircraft-${index}`}>{row.aircraft}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </>
            ) : (
                showErrorMassage()
            )}
        </TableContainer>
    )
}

export default FlightStatusTable
